
export default function TotalRow({ id, label, className = '', value, grantPercent }) {
    return (
        <div className={`total-row ${className}`} id={id}>
            <span className="row-title">{label}{(grantPercent) ? <>&nbsp;({grantPercent}%)</> : <></>}</span>
            <span className="row-value"><span className="shekel-mrk">₪</span>{value?.toLocaleString('he-IL', { maximumFractionDigits: 2 })}</span>
        </div>
    )
}
